import { Stack, Box } from '@mui/material'
import React from 'react'

import LabelledSwitch, { LabelledSwitchProps } from './LabelledSwitch'
import type { Dispatch } from 'redux'
import { useAppSelector } from 'redux/Hook'

interface ControlledFieldGroupProps {
  id: string
  label: string
  labelProps?: LabelledSwitchProps
  onChange: (name: string, value: boolean, dispatch: Dispatch) => void
  children?: React.ReactNode
  indent?: boolean
}

const ControlledFieldGroup = (props: ControlledFieldGroupProps) => {
  const { id, label, labelProps, onChange, children, indent } = props

  const isChecked = useAppSelector(
    (state) => state.toolBuilder.toolBuilder?.[id],
  )

  return (
    <Stack spacing={1}>
      <Box>
        <LabelledSwitch
          id={id}
          label={label}
          {...labelProps}
          onChange={onChange}
        />
      </Box>

      {isChecked && (
        <Stack spacing={2} {...(indent && { pl: 5 })}>
          {children}
        </Stack>
      )}
    </Stack>
  )
}
export default ControlledFieldGroup
